import styled from 'styled-components'
import breakpoint from 'styled-components-breakpoint'
import { Link } from 'gatsby'

export const Container = styled.div`
  padding: 2rem 6rem;
  background-color: #363636;
  display: grid;
  gap: 2rem;

  ${breakpoint('desktop')`
    justify-items: center;
    grid-template-columns: 1fr 1fr 1fr;
  `}
`

export const Img = styled.img`
  width: 200px;
  height: auto;

  ${breakpoint('tablet')`
    width: auto;
    height: 100px;
  `}
`

export const Fsa = styled.img`
  height: 150px;
`

export const Accolades = styled.div`
  justify-self: center;
  text-align: center;

  ${breakpoint('desktop')`
    margin-top: 0;
  `}
`

export const A = styled.a`
  color: white;
  word-wrap: break-word;
  transition: 0.3s;

  &:hover {
    color: #C83337;
  }
`

export const Contact = styled.div`
  justify-self: center;
  text-align: center;

  > p {
    text-align: center;
  }

  ${breakpoint('desktop')`
    justify-self: start;
    text-align: left;

    > p {
      text-align: left;
    }
  `}
`

export const NavList = styled.ul`
  justify-self: center;

  ${breakpoint('desktop')`
    justify-self: end;
  `}

  list-style: none;
  padding: 0;
  margin: 0;
`

export const NavItem = styled.li`
  width: 100%;
  margin: 0;
  padding: 0;
`

export const NavLink = styled(Link)`
  display: block;
  margin: 0;
  padding: 0.5rem 0;
  color: white;
  text-decoration: none;
  font-weight: bold;
  font-size: 1.2rem;
  transition: 0.3s;
  text-align: center;

  ${breakpoint('desktop')`
    text-align: right;
  `}

  &:hover {
    color: #C83337;
  }

  &.active {
    color: #C83337;
    cursor: default;
    pointer-events: none;
  }
`
